import React, { PropsWithChildren } from 'react';

import { Stack } from '@mui/material';

export default function StickyFormActions({ children }: PropsWithChildren) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      flexWrap="wrap"
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 1,
        bgcolor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider',
        py: 2,
        mt: 3,
      }}
    >
      {children}
    </Stack>
  );
}
